export const AVAILABLES_LEVEL = [
  { value: 'hibernation', color: '#7A8096', bgcolor: '#E5E7EB' },
  { value: 'planned', color: '#0879A6', bgcolor: '#DBE8FE' },
  { value: 'event', color: '#D9AA1E' },
  { value: 'up', color: '#587F31', bgcolor: '#E6F0D7' },
  { value: 'works', color: '#B98B3C', bgcolor: '#ECE4D4' },
  { value: 'spare', color: '#8961BD', bgcolor: '#F4ECFE' },
  { value: 'muted', color: '#94D7F2' },
  { value: 'down', color: '#FF0000', bgcolor: '#FEE2E2' },
  { value: 'degraded', color: '#F59E0B', bgcolor: '#FFF8EB' },
]

export const BYPASSES_DISCLAIMER_KEY = 'bypasses_disclaimer'
export const SUPPORT_PHONE_ALERT_KEY = 'support_phone_alert'

export default AVAILABLES_LEVEL
